var _use, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      backgroundColor: "#fff"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 726,
    height: 885,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-17.582 -4.664 71.571 87.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    stroke: "#003893",
    strokeWidth: 5.165,
    xlinkHref: "#a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#DC143C",
    d: "M-15 37.57h60L-15 0v80h60l-60-60z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35.43c6.6 0 11.95-5.35 11.95-11.95a12.802 12.802 0 01-5.37 6.32l-1.02-.76 2-1.5-2.42-.62 1.28-2.17-2.5.36.37-2.48-2.17 1.3-.62-2.45-1.5 2-1.5-2-.63 2.44-2.16-1.28.37 2.5-2.5-.37 1.3 2.17-2.44.62 2 1.5-1 .77c-2.37-1.4-4.3-3.56-5.38-6.32 0 6.6 5.35 11.95 11.95 11.95zM-5.76 53.03l-5.36-.66 3.25 4.3-4.97 2.12 4.97 2.1-3.25 4.3 5.36-.66-.66 5.37 4.3-3.25L0 71.63l2.1-4.98 4.32 3.26-.66-5.36 5.36.67-3.25-4.3 4.97-2.1-4.97-2.12 3.25-4.3-5.36.65.66-5.36-4.3 3.25L0 45.95l-2.1 4.97-4.32-3.25.66 5.36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.8508b0e17ce66bb7121d73854aab2be5.svg";
export { ForwardRef as ReactComponent };